module.exports = __webpack_public_path__ + "../resources/img/img_ef_layer1_no-inverter.b730ca08.svg";